import { css } from '@emotion/react'
import mediaQueries from './media-queries'

export const navStyles = ({ colors, spacing }) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  height: 80;
  max-height: 80;
  overflow: visible;
  background: ${colors.white};

  padding-left: ${spacing.s};
  padding-right: ${spacing.s};

  ${mediaQueries.smallScreen()} {
    padding-left: ${spacing.m};
    padding-right: ${spacing.m};
  }
`

export const mainStyles = (isFooterHidden, hideBottomPadding) => css`
  padding: ${isFooterHidden ? `0` : `0 16px 60px`};
  ${hideBottomPadding ? `padding-bottom: 0;` : ''}

  ${mediaQueries.smallScreen()} {
    padding: ${isFooterHidden ? `0` : `0 32px 60px`};
    ${hideBottomPadding ? `padding-bottom: 0;` : ''}
  }
`

export const contentStyles = (hideBottomPadding) => ({
  maxWidth,
  spacing,
}) => css`
  max-width: ${maxWidth};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 0 0px ${hideBottomPadding ? 0 : spacing.xl};
`

export const footerStyles = css`
  background: #2e2e2e;
  color: #fff;
  minheight: 100;
  padding: 50px 100px;
  text-align: center;
`
